import styled from './financeiro.module.css';
import Menu from '../../components/Menu';
import Header from '../../components/Header';
import Parcelas from '../../components/Parcelas';


function Financeiro() {
    return (
        <div className={styled.page}>
            <Menu menu="financeiro" />
            <div className={styled.container}>
                <Header page="Financeiro" />
                <div className={styled.card}>
                    <div className={styled.cardheader}>
                        <div className={styled.cardtitle}>
                            <a>Financeiro</a>
                            <div className={styled.cardline}></div>
                        </div>
                    </div>
                    <div className={styled.cardcontent}>
                        <div className={styled.appboletos}>
                            
                            <Parcelas />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default Financeiro;